import { Trash2, Clock } from "lucide-react";
import { mediaSrc, fmtDuration } from "@/lib/api";

export const ClipCard = ({ clip, tags, tag, onTag, onRemove, disabled }) => (
  <div className="card-surface overflow-hidden group" data-testid={`clip-card-${clip.clip_id}`}>
    <div className="relative aspect-[9/16] bg-black/60">
      {clip.thumb_url ? (
        <img src={mediaSrc(clip.thumb_url)} alt={clip.filename} className="absolute inset-0 w-full h-full object-cover" />
      ) : (
        <div className="absolute inset-0 grid place-items-center text-xs text-muted-foreground">No preview</div>
      )}
      <span className="absolute top-2 left-2 rounded-md bg-black/70 text-white px-1.5 py-0.5 text-[10px] font-mono flex items-center gap-1">
        <Clock size={10} /> {fmtDuration(clip.duration)}
      </span>
      {!disabled && (
        <button onClick={() => onRemove(clip.clip_id)} className="absolute top-2 right-2 h-7 w-7 rounded-lg bg-black/70 text-white grid place-items-center opacity-0 group-hover:opacity-100 transition-opacity hover:text-destructive" data-testid={`clip-remove-${clip.clip_id}`} aria-label="Remove clip">
          <Trash2 size={14} />
        </button>
      )}
    </div>
    <div className="p-2 space-y-1.5">
      <p className="text-[11px] text-muted-foreground truncate font-mono" title={clip.filename}>{clip.filename}</p>
      <div className="grid grid-cols-2 gap-1">
        {tags.map((t) => (
          <button
            key={t.id}
            onClick={() => onTag(clip.clip_id, t.id)}
            disabled={disabled}
            title={t.hint}
            className={`chip text-[10px] justify-center ${tag === t.id ? "chip-active" : "chip-idle"}`}
            data-testid={`clip-tag-${clip.clip_id}-${t.id}`}
          >
            {t.label}
          </button>
        ))}
      </div>
    </div>
  </div>
);
